import { GetterTree } from 'vuex';
import { IProfileNotificationState } from './profile-notification-state.store';
import { IRootState } from '../root-state.store';
//@ts-ignore
import { ActivityStatus } from '@/common/enums';

export const getters: GetterTree<IRootState, IProfileNotificationState> = {
  service: (state: IRootState) => state.service
  , activityStatus: (state: IRootState): ActivityStatus => {
    return state.activityStatus;
  },
  profileNotifications: (state: IProfileNotificationState) => state.profileNotifications,
  profileNotificationsTitles: (state: IProfileNotificationState) => {
    return state.profileNotifications.map(profileNotification => profileNotification.section_notification_name)
  },
  loaders: (state: IProfileNotificationState) : Map<string,boolean> => state.loaders
}



// WEBPACK FOOTER //
// ./src/store/profile-notification/profile-notification-getters.store.ts